/** @format */

import UploadDesigns from '@/account/components/upload_designs/container';
import {Modal, ModalHeader} from '@sttark/design-system';
import {DesignsUpdated} from './designs_updated';
import {IfElse} from 'frontier-utilities';
import React, {useState} from 'react';
import DesignUploader from 'frontier/account/components/design_uploader/container';

export const UploadArtworkModal = props => {
    const {designsOrders, order} = props;

    const [isShowingUpload, setShowingUpload] = useState(false);
    const [uploadedDesigns, setUploadedDesigns] = useState([]);

    const handeCloseModal = () => {
        if (uploadedDesigns.length > 0) {
            // We uploaded designs, reload the page
            window.location.reload();
        } else {
            setShowingUpload(false);
        }
    };
    return (
        <div>
            <div className="color-accent-primary d-flex align-items-center justify-content-start gap-1">
                <i className="fa fa-pen-to-square" />
                <button onClick={() => setShowingUpload(true)} className="btn btn-sm btn-link p-0">
                    Replace Artwork
                </button>
            </div>
            <Modal isOpen={isShowingUpload} onClose={handeCloseModal} bodyHeightAuto>
                <ModalHeader onClose={handeCloseModal}>Replace Artwork</ModalHeader>
                <IfElse condition={uploadedDesigns.length === 0}>
                    <UploadDesigns
                        orderId={order.id}
                        isAdmin={false}
                        designsOrders={designsOrders}
                        onSave={designsOrders => {
                            setUploadedDesigns(designsOrders);
                        }}
                    />
                    <DesignsUpdated uploadedDesigns={uploadedDesigns} />
                </IfElse>
            </Modal>
        </div>
    );
};
